module.exports = __webpack_public_path__ + "03_short_brown.a8a1f848.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/03_short_brown.png
// module id = GgZs
// module chunks = 0